module.exports = __webpack_public_path__ + "img/jingluoyi.d62369e6.png";